import React from "react";

export default function Footer() {
  return (
    <div className="wireframe__footer">
      <span>@Black Lotus 2019 | Brought to you by iamblacklotus.com</span>
    </div>
  );
}
